'use client'

import { ThirdPartyFormsTableModule } from '@repo/third-party-forms-table/ThirdPartyFormsTableModule'

export const ThirdPartyFormsTable = () => {
  return <ThirdPartyFormsTableModule />
}

export default ThirdPartyFormsTable
